import Axios from "../../helpers/axios";

// export const updateMentor = (mentor_id, body) => {
//   return Axios.patch(`/mentors/${mentor_id}`, body);
// };

// export const createNewMentor = (body) => {
//   return Axios.post(`/mentors/create`, body);
// };

// export const changeMentorStatus = (mentor_id, body) => {
//   return Axios.patch(`/mentors/active-status/${mentor_id}`, body);
// };

//

export const getAllMentorTopics = (user_id) => {
  return Axios.get(`/mentors/topic-mentor/${user_id}`);
};

export const getAllMentorSchedules = (mentor_id, params) => {
  return Axios.get(
    `/mentors/get-schedules/${mentor_id}`,
    params ? { params } : null
  );
};

export const getMentorSchedulesAllTime = (mentor_id) => {
  return Axios.get(`/mentors/get-schedules-all/${mentor_id}`);
};

export const getScheduleTimeslot = (mentor_id, params) => {
  return Axios.get(
    `/mentors/get-schedule-timeslots/${mentor_id}`,
    params ? { params } : null
  );
};

export const createMentorSchedule = (mentor_id, body, params) => {
  return Axios.post(`/mentors/add-schedule/${mentor_id}`, body, {
    params,
  });
};

export const createMultipleTopics = (mentorTopicsId) => {
  return Axios.post(`/mentors/add-topics`, null, {
    params: {
      topicId: mentorTopicsId,
    },
  });
};

export const editMentorSchedule = (mentor_id, body, params) => {
  return Axios.patch(`/mentors/edit-schedule/${mentor_id}`, body, {
    params,
  });
};

export const deleteMentorSchedule = (mentor_schedule_id) => {
  return Axios.delete(`/mentors/delete-schedule/${mentor_schedule_id}`);
};
